<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
  {{ 'caad.modifier-coordonnees.sousTitre' | translate }}
</h1>
<h2>{{ 'caad.modifier-coordonnees.titre' | translate }}</h2>
<dsd-form [formGroup]="formBancaire">
  <span class="dsd-form-required">{{ 'caad.modifier.coordonnees.ajoutedechamps' | translate }}</span>
  <dsd-container>
    <h3 class="dsd-t-4 dsd-mb-md">{{ 'caad.modifier-coordonnees.adresse.titre' | translate }}</h3>
    <app-modification-adresse
      [formGroup]="formBancaire"
      [isBancaire]="true"
      [adresseCourante]="adresseCourante"></app-modification-adresse>
    <h3 class="dsd-t-4 dsd-mb-md">{{ 'caad.modifier-coordonnees.courriel.titre' | translate }}</h3>
    <app-modification-courriel
      [formGroup]="formBancaire"
      [required]="false"
      [maxLength]="64"></app-modification-courriel>
  </dsd-container>
  <div class="zone-btn">
    <dsd-button variant="primary" full-width="xs" type="submit" (dsdButtonClick)="naviguerVersPageValidation()">{{
      'caad.button.valider' | translate
    }}</dsd-button>
    <dsd-button full-width="xs" (dsdButtonClick)="annulerModification()">{{
      'caad.button.annuler' | translate
    }}</dsd-button>
  </div>
</dsd-form>
